export const SEARCH_COMPANIES_PROCESS = 'searchCompanies';
export const SEARCH_COMPANY_HOLDER = 'Search a company by name';
export const COMPANIES_GET_PROCESS = 'getCompanies';
export const COMPANY_BY_ID_PROCCESS = 'getCompanyById';
export const COMPANY_UPDATE_PROCCESS = 'companyUpdate';
export const COMPANY_CREATE_PROCCESS = 'companyCreate';
export const COMPANY_DELETE_PROCCESS = 'companyDelete';
export const COMPANY_PAGE_SIZE = 40;
export const ASSIGN_ALIAS_COMPANY = 'Assign an alias to this company';
export const ASSIGN_NAME_COMPANY = 'Assign a custom name to this company';
export const SEARCH_COMPANY = 'Search the company to add by its name';
export const COMPANY_ALIASES = 'aliases';
export const COMPANY_CUSTOM_NAME = 'customNames';
export const COMPANY_ALIASES_LABEL = 'Alias';
export const COMPANY_CUSTOM_NAME_LABEL = 'Custom name';
